/**
 * Role Assignment Entity Schemas
 *
 * Mirrors the Prisma UserRoleAssignment model.
 */

import { z } from 'zod'
import { RoleSummarySchema } from './role'

export const RoleAssignmentCreatedViaSchema = z.enum(['API', 'BACKFILL', 'SEED'])
export type RoleAssignmentCreatedVia = z.infer<typeof RoleAssignmentCreatedViaSchema>

export const RoleAssignmentSchema = z.object({
  id: z.string().describe('Role assignment public ID (cuid)'),
  usersOnSchoolsId: z.string().describe('Target school user public ID'),
  role: RoleSummarySchema,
  scopeType: z
    .string()
    .nullable()
    .describe('Reserved for v2 (group/section/department-level scoping). Always null in v1.'),
  scopeId: z.string().nullable().describe('Reserved for v2.'),
  grantedByUosId: z
    .string()
    .nullable()
    .describe('Granting school-user public ID. Null when granted by a system actor (e.g., backfill).'),
  grantedAt: z.string().describe('ISO timestamp'),
  createdVia: RoleAssignmentCreatedViaSchema
})

export type RoleAssignment = z.infer<typeof RoleAssignmentSchema>
